import { configureStore } from '@reduxjs/toolkit';
import {Policy} from "../objects/policy";
import { SystemFlags } from '../objects/systemFlags';

const systemFlagsReducerFunction = (state : SystemFlags | undefined | null, action : any)  =>{

    if(action.type == "ORDER_PREFILL"){
        var settings = {...(action.payload as SystemFlags)};
        settings.hasPrefill = true;
        return settings;
    }

    return (state as SystemFlags) == undefined ? null : (state as SystemFlags);
};

export default systemFlagsReducerFunction;